import { cn } from "../../../lib/cn";

const colorStyles = {
  primary: "bg-primary/10 text-primary",
  secondary: "bg-secondary/10 text-secondary-dark",
  success: "bg-success/10 text-success",
  danger: "bg-danger/10 text-danger",
  warning: "bg-warning/10 text-warning",
  neutral: "bg-surface-active text-darkgrey",
};

const dotColorStyles = {
  primary: "bg-primary",
  secondary: "bg-secondary",
  success: "bg-success",
  danger: "bg-danger",
  warning: "bg-warning",
  neutral: "bg-darkgrey",
};

const sizeStyles = {
  sm: "text-[10px] px-2 py-0.5",
  md: "text-xs px-2.5 py-1",
  lg: "text-sm px-3 py-1.5",
};

/**
 * Badge — compact status/role indicator.
 * Replaces hand-rolled status dots, role pills, and status labels.
 */
export const Badge = ({
  color = "neutral",
  size = "md",
  dot = false,
  children,
  className,
}) => {
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 font-sans font-semibold rounded-full whitespace-nowrap select-none",
        colorStyles[color],
        sizeStyles[size],
        className,
      )}
    >
      {dot && (
        <span
          className={cn(
            "rounded-full flex-shrink-0",
            size === "sm" ? "w-1.5 h-1.5" : "w-2 h-2",
            typeof dot !== "string" && dotColorStyles[color],
          )}
          style={typeof dot === "string" ? { backgroundColor: dot } : undefined}
        />
      )}
      {children}
    </span>
  );
};
